const chains = [];
chains.push({ _operation: 'createExternalPartyRelationship', api: '/external-party-relationship', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'deleteExternalPartyRelationshipById', api: '/external-party-relationship/:objectId', defaultData: null, httpVerb: 'delete' });
chains.push({ _operation: 'getExternalPartyRelationships', api: '/external-party-relationships', defaultData: [], httpVerb: 'get' });
export default chains;
